import { CSSProperties, useMemo } from 'react';
import { StaticImageData } from 'next/image';
import styles from './styles.module.css';
import homeBg from '../../../public/images/home.webp';
import basicBg from '../../../public/images/basic.png';

interface BackgroundProps {
  imageUrl?: string | StaticImageData;
  bgVariant?: 'basic' | 'home';
}

export const Background = ({ imageUrl, bgVariant }: BackgroundProps) => {
  const bgImage = useMemo(() => {
    switch (bgVariant) {
      case 'basic':
        return (basicBg as unknown as StaticImageData).src;
      case 'home':
        return (homeBg as unknown as StaticImageData).src;
      default:
        if (typeof imageUrl === 'string') {
          return imageUrl;
        } else if (imageUrl) {
          return imageUrl.src;
        }
        return '';
    }
  }, [bgVariant, imageUrl]);

  if (!imageUrl && !bgVariant) return null;

  const backgroundStyle: CSSProperties = {
    background: `url(${bgImage}) top/cover no-repeat`,
  };

  return <div className={styles.background} style={backgroundStyle} />;
};
